import { createAuthClient } from 'better-auth/react';
import { env } from '../env.js';

export const authClient = createAuthClient({
  baseURL: env.apiUrl,
  basePath: '/api/auth',
  fetchOptions: {
    credentials: 'include',
  },
});

export const { signIn, signOut, useSession, linkSocial } = authClient;
